import useV2Query from 'utils/useV2Query';
import { GET_LEDGER_ACCOUNT_DISPLAY_GROUPS } from './queries';

const useDisplayGroups = () => {
  const { loading, error, data } = useV2Query(GET_LEDGER_ACCOUNT_DISPLAY_GROUPS, {
    fetchPolicy: 'cache-first', // Use cache if available
  });

  return {
    displayGroups: data?.ledgerAccountDisplayGroups || [],
    isLoading: loading,
    hasError: error,
  };
};

export default useDisplayGroups;
